import { SimpleGrid, Text } from '@backyard-ui/core';

import { type Installment } from '@/infra/services/catalog/model';
import { formatPrice } from '@/utils/price/formatPrice';

import styles from './PaymentMethods.styles';

interface PaymentRowProps {
  installment: Installment;
}

const PaymentRow = (props: PaymentRowProps) => {
  const { installment } = props;
  const { quantity, price, totalPrice } = installment;

  return (
    <SimpleGrid columns={3} gapX="4" className={styles()}>
      <Text size="md" weight="bold">
        {quantity}x de {formatPrice(price)}
      </Text>
      <Text size="md">s/ juros</Text>
      <Text size="md">total {formatPrice(totalPrice)}</Text>
    </SimpleGrid>
  );
};

export default PaymentRow;
